import api, { ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { SimularFolhaRequest, SimuladorFolhaResultado } from './simulador-folha.types';

const endpoint = Endpoints.SIMULADOR_FOLHA;

export async function simularFolha(dto: SimularFolhaRequest): Promise<SimuladorFolhaResultado> {
  try {
    const response = await api.post<SimuladorFolhaResultado>(`${endpoint}/simular`, dto);
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao simular folha de pagamento.');
  }
}
